module.exports = __webpack_public_path__ + "img/146-62-flat.5897a8cb.jpg";